export class UIDCareersSceneController {
    hide() {
        this.careersSceneContainerDiv.classList.add('hidden');
    }
    show() {
        this.careersSceneContainerDiv.classList.remove('hidden');
        this.sidebarController.deactivateAllButtons();
    }
    constructor(sidebarController){
        this.sidebarController = sidebarController;
        this.careersSceneContainerDiv = document.getElementById('scene_discord_careers_container');
    }
}
